import ChangeBusinessUserModal from './change-business-user-modal.vue'
export default ChangeBusinessUserModal
